// src/api.js
import axios from 'axios';

const HTTP_BASE_URL = 'https://api.zatamap.com/api';
//const HTTP_BASE_URL = 'http://127.0.0.1:5001/api';
const httpApi = axios.create({
  baseURL: HTTP_BASE_URL,
  headers: {
    'Content-Type': 'application/json',
  },
});

export { httpApi };